import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PageTitle from '../../../../components/Accessibility/PageTitle';
import DefaultPagination from '../../../../components/Accessibility/DefaultPagination';
import VoltarButton from '../../../../components/Accessibility/VoltarButton';
import LoadingApp from '../../../../components/LoadingApp';
import { useAccessibility } from '../../../../Store/contexts/AccessibilityContext';
import TranscricaoListaTable from './TranscricaoListaTable';
import TranscricaoListaEmptyState from './TranscricaoListaEmptyState';
import { useConsultarTranscricaoLista } from './hooks/useConsultarTranscricaoLista';
import './styles.css';

const ConsultarTranscricao: React.FC = () => {
  const navigate = useNavigate();
  const accessibility = useAccessibility();
  const {
    loading,
    erro,
    listaVisivel,
    paginatedLista,
    page,
    totalPages,
    pageSize,
    handlePageChange,
    handleVerDetalhes,
  } = useConsultarTranscricaoLista();

  return (
    <div className="consultar-transcricao-container">
      <PageTitle
        text="Minhas transcrições"
        className="consultar-transcricao-title"
        id="consultar-transcricao-title"
      />

      <LoadingApp showLoading={loading} />

      {!loading && erro && (
        <Typography style={accessibility.textStyleAccessibility} className="consultar-transcricao-erro">
          {erro}
        </Typography>
      )}

      {!loading && !erro && listaVisivel.length === 0 && (
        <TranscricaoListaEmptyState />
      )}

      {!loading && !erro && listaVisivel.length > 0 && (
        <div className="consultar-transcricao-lista-area">
          <TranscricaoListaTable itens={paginatedLista} onVerDetalhes={handleVerDetalhes} />

          <Typography
            style={accessibility.textStyleAccessibility}
            className="consultar-transcricao-contagem"
          >
            {`Mostrando ${listaVisivel.length} de ${listaVisivel.length} solicitações`}
          </Typography>

          {listaVisivel.length > pageSize && (
            <div className="consultar-transcricao-pagination">
              <DefaultPagination
                currentPage={page}
                totalPages={totalPages}
                handlePageChange={handlePageChange}
              />
            </div>
          )}
        </div>
      )}

      <div className="consultar-transcricao-actions">
        <VoltarButton onClick={() => navigate(-1)} />
      </div>
    </div>
  );
};

export default ConsultarTranscricao;
